export const GRID = {
  VerticalPaddingsDetailsPage: '--grid-vertical-paddings-details-page',
  VerticalGapBetweenTitleAndGrid: '--grid-vertical-gap-between-title-and-grid',
  VerticalPaddingsSearchPage: '--grid-vertical-paddings-search-page',
  VerticalPaddingsGridMotn: '--grid-vertical-paddings-grid-motn',
  VerticalPaddingsLoaderMotn: '--grid-vertical-paddings-loader-motn',
  VerticalPaddingsDetailsRecommendations:
    '--grid-vertical-paddings-details-recommendations',
  HorizontalPaddingsDetailsRecommendations:
    '--grid-horizontal-paddings-details-recommendations',
  TitleGapDetailsRecommendations: '--grid-title-gap-details-recommendations',
  GapDetailsRecommendations: '--grid-gap-details-recommendations',
  PaddingTopDetailsEpisodes: '--grid-padding-top-details-episodes',
  PaddingBottomDetailsEpisodes: '--grid-padding-bottom-details-episodes',
  HorizontalPaddingsDetailsEpisodes:
    '--grid-horizontal-paddings-details-episodes',
  GapDetailsEpisodes: '--grid-gap-details-episodes',
} as const
export type GRID = (typeof GRID)[keyof typeof GRID]
